import carTrajectory from "../CarTrajectory";
import carMonitor from "../CarMonitor";
/**
 *数据路由
 */
const monitor = [
    {
        name: '车辆监控',
        path: '/monitor/carMonitor',
        component: carMonitor
    },
    {
        name: '车辆轨迹实时监控',
        path: '/monitor/carTrajectory',
        component: carTrajectory
    },
];
export default monitor
